import { styled } from 'goober'

export const ImportButtonWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0.5em;
`

export const ErrorText = styled('span')`
  color: var(--error);
`
